import {useNavigate} from "react-router-dom";
import React, {useState} from "react";
import {MagneticButton} from "../../";
import "./HorizontalAccordion.css";

const HorizontalAccordion = ({items}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  // Reset to first item when cursor leaves any item
  const handleItemLeave = () => {
    setActiveIndex(0);
  };

  const navigate = useNavigate();

  return (
    <div className="services-horizontal-accordion services-alter-hover">
      {items.map((item, index) => {
        const isActive = index === activeIndex;
        const isInactive = index !== activeIndex;

        return (
          <div
            key={index}
            className={`services-horizontal-accordion-item ${
              isActive ? "active" : ""
            } ${isInactive ? "inactive" : ""}`}
            onMouseEnter={() => setActiveIndex(index)}
            onMouseLeave={handleItemLeave}
          >
            <div className="services-horizontal-accordion-item-inner">
              <div className="services-horizontal-accordion-item-count">
                <span>0{index + 1}</span>
              </div>
              <div className="services-horizontal-accordion-item-content">
                <div className="services-horizontal-accordion-content-top">
                  <h3 className="services-horizontal-accordion-title">
                    {item.title} <br />
                    {item.title2}
                  </h3>
                  <p className="services-horizontal-accordion-description">
                    {item.description}
                  </p>
                </div>
                <div className="service-horizontal-accordion-bottom">
                  <MagneticButton
                    to="/services"
                    className="tt-btn tt-btn-outline tt-magnetic-item"
                  >
                    Read More
                  </MagneticButton>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default HorizontalAccordion;
